import { getMessages } from '../../../../../store/constants';

export const VIEW_SETTINGS = getMessages().getText('list_view.view_settings');
export const GROUP_EPIC = getMessages().getText('list_view.group_epics_toggler');
export const EXPAND_GROUP = getMessages().getText('list_view.groups_collapse_toggler.expand');
